import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import {NodeProps} from 'reactflow';

import {FONT_PROXIMA_11, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';

export const GROUP_TITLE_GAP = 4; // Gap between title and group box

export enum NodeType {
  HOVER_GROUP = 'HOVER_GROUP',
  SELECTION_GROUP = 'SELECTION_GROUP',
}

export interface GroupFlowchartNodeData {
  title: string;
  isHover: boolean;
  width: number;
  height: number;
}

export default function GroupFlowchartNode({data}: NodeProps<GroupFlowchartNodeData>): JSX.Element {
  const {title, isHover, width, height} = data;

  return (
    <div className={css(styles.container)}>
      <div
        className={classNames(
          css(styles.title),
          isHover ? css(styles.hoverTitle) : css(styles.selectionTitle)
        )}
      >
        {title}
      </div>
      <div
        className={classNames(
          css(styles.groupBox),
          isHover ? css(styles.hoverGroupBox) : css(styles.selectionGroupBox)
        )}
        style={{
          width: width || 200,
          height: height || 100,
        }}
      />
    </div>
  );
}

/* Exported for testing */
export const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: `${GROUP_TITLE_GAP}px`,
  },
  title: {
    ...FONT_PROXIMA_11,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    padding: '2px 6px',
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    alignSelf: 'flex-start',
  },
  hoverTitle: {
    color: Color.WHITE,
    backgroundColor: Color.GRAY_700,
  },
  selectionTitle: {
    color: Color.WHITE,
    backgroundColor: Color.BLUE_450,
  },
  hoverGroupBox: {
    borderColor: Color.GRAY_500,
  },
  selectionGroupBox: {
    borderColor: Color.BLUE_450,
  },
  groupBox: {
    borderRadius: '4px',
    border: `1px solid`,
  },
});
